import React, { useState, useEffect } from 'react';
import {
  Document, Page, View, Text, StyleSheet, Image, pdf
} from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import logoUrl from '../assets/logo.png';

const BK = '#000000';
const BORDER = '#000000';

const s = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 40,
    fontFamily: 'Helvetica',
    fontSize: 8,
    color: BK,
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: BK,
    paddingBottom: 8,
  },
  logo: {
    width: 50,
    height: 50,
    objectFit: 'contain',
  },
  headerTextContainer: {
    flex: 1,
    marginLeft: 12,
  },
  title: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    textTransform: 'uppercase',
  },
  subtitle: {
    fontSize: 9,
    marginTop: 2,
    color: '#444',
  },
  section: {
    marginTop: 10,
    marginBottom: 5,
  },
  sectionTitle: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    backgroundColor: '#f1f5f9',
    padding: 4,
    marginBottom: 6,
    borderWidth: 0.5,
    borderColor: BORDER,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderWidth: 0.5,
    borderColor: BORDER,
  },
  gridItem: {
    padding: 4,
    borderRightWidth: 0.5,
    borderRightColor: BORDER,
    borderBottomWidth: 0.5,
    borderBottomColor: BORDER,
  },
  label: {
    fontSize: 6,
    fontFamily: 'Helvetica-Bold',
    color: '#666',
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  value: {
    fontSize: 8,
  },
  sniRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2,
    borderBottomWidth: 0.3,
    borderBottomColor: '#ccc',
  },
  sniLabel: {
    flex: 1,
  },
  sniValue: {
    width: 30,
    textAlign: 'center',
    fontFamily: 'Helvetica-Bold',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 7,
    color: '#999',
    borderTopWidth: 0.5,
    borderTopColor: '#ccc',
    paddingTop: 5,
  }
});

const urlParaBase64 = (url) => {
  if (!url || typeof url !== 'string' || url.startsWith('data:')) return Promise.resolve(url);
  return new Promise((resolve) => {
    const el = document.createElement('img');
    el.crossOrigin = 'anonymous';
    el.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width  = el.naturalWidth;
        canvas.height = el.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(el, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch (err) { resolve(null); }
    };
    el.onerror = () => resolve(null);
    el.src = url;
  });
};

export const FormularioLocalidadePDFDocument = ({ form, logoBase64 }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const parts = dateStr.split('-');
      if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      return dateStr;
    } catch (e) { return dateStr; }
  };

  const renderSNI = (label, val) => (
    <View style={s.sniRow}>
      <Text style={s.sniLabel}>{label}</Text>
      <Text style={s.sniValue}>{val || '-'}</Text>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={s.page}>
        <View style={s.header}>
          <Image src={logoBase64 || logoUrl} style={s.logo} />
          <View style={s.headerTextContainer}>
            <Text style={s.title}>RECONHECIMENTO GEOGRÁFICO</Text>
            <Text style={s.subtitle}>Vigilância Entomológica e Controle de Vetores</Text>
          </View>
        </View>

        <View style={s.section}>
          <Text style={s.sectionTitle}>Identificação</Text>
          <View style={s.grid}>
            <View style={[s.gridItem, { width: '20%' }]}><Text style={s.label}>Tipo</Text><Text style={s.value}>{form.tipo_registro === 'inclusao' ? 'Inclusão' : 'Alteração'}</Text></View>
            <View style={[s.gridItem, { width: '40%' }]}><Text style={s.label}>UF</Text><Text style={s.value}>{form.codigo_uf || '-'}</Text></View>
            <View style={[s.gridItem, { width: '40%', borderRightWidth: 0 }]}><Text style={s.label}>Município</Text><Text style={s.value}>{form.codigo_municipio_ibge || '-'}</Text></View>
            
            <View style={[s.gridItem, { width: '20%' }]}><Text style={s.label}>Código</Text><Text style={s.value}>{form.codigo || '-'}</Text></View>
            <View style={[s.gridItem, { width: '40%' }]}><Text style={s.label}>Nome Localidade</Text><Text style={s.value}>{form.nome || '-'}</Text></View>
            <View style={[s.gridItem, { width: '40%', borderRightWidth: 0 }]}><Text style={s.label}>Categoria</Text><Text style={s.value}>{form.categoria || '-'}</Text></View>

            <View style={[s.gridItem, { width: '25%' }]}><Text style={s.label}>Data RG</Text><Text style={s.value}>{formatDate(form.data_rg)}</Text></View>
            <View style={[s.gridItem, { width: '25%' }]}><Text style={s.label}>Data Atualização</Text><Text style={s.value}>{formatDate(form.data_atualizacao)}</Text></View>
            <View style={[s.gridItem, { width: '25%' }]}><Text style={s.label}>Status</Text><Text style={s.value}>{form.status_localidade === '2' ? 'Extinta' : 'Ativa'}</Text></View>
            <View style={[s.gridItem, { width: '25%', borderRightWidth: 0 }]}><Text style={s.label}>Classificação</Text><Text style={s.value}>{form.classificacao || '-'}</Text></View>
          </View>
        </View>

        <View style={{ flexDirection: 'row', gap: 10 }}>
          <View style={{ flex: 1.2 }}>
            <Text style={s.sectionTitle}>Infraestrutura</Text>
            <View style={{ paddingHorizontal: 5 }}>
                {renderSNI('Energia Elétrica', form.infra_energia_eletrica)}
                {renderSNI('Água Encanada', form.infra_agua_encanada)}
                {renderSNI('Tratamento Esgoto', form.infra_tratamento_esgoto)}
                {renderSNI('Lavanderia Coletiva', form.infra_lavanderia_coletiva)}
                {renderSNI('Casas com Privada', form.infra_casas_privada)}
                {renderSNI('Coleta de Lixo', form.infra_coleta_lixo)}
                {renderSNI('Rede Telefônica', form.infra_rede_telefonica)}
                {renderSNI('Transporte Público', form.infra_transporte_publico)}
                {renderSNI('PACS / PSF', form.infra_pacs_psf)}
            </View>

            <Text style={[s.sectionTitle, { marginTop: 10 }]}>Ocorrências</Text>
            <View style={{ paddingHorizontal: 5 }}>
                <View style={{ borderBottomWidth: 0.5, borderBottomColor: '#000', marginBottom: 2 }}>
                  <Text style={{ fontSize: 7, fontFamily: 'Helvetica-Bold' }}>Ocorrência de animais</Text>
                  <Text style={{ fontSize: 6, color: '#555' }}>S-Sim · N-Não · I-Ignorado</Text>
                </View>
                {renderSNI('Cachorros', form.ocor_animais_cachorros)}
                {renderSNI('Gatos', form.ocor_animais_gatos)}
                {renderSNI('Roedores', form.ocor_animais_roedores)}

                <View style={{ marginTop: 6, borderBottomWidth: 0.5, borderBottomColor: '#000', marginBottom: 2 }}>
                  <Text style={{ fontSize: 7, fontFamily: 'Helvetica-Bold' }}>Ocorrência ou risco de ocorrência</Text>
                  <Text style={{ fontSize: 6, color: '#555' }}>S-Sim · N-Não · I-Ignorado</Text>
                </View>
                {renderSNI('Doença de Chagas', form.ocor_doenca_chagas)}
                {renderSNI('Malária', form.ocor_malaria)}
                {renderSNI('Dengue', form.ocor_dengue)}
                {renderSNI('Leishmaniose', form.ocor_leishmaniose)}
                {renderSNI('Esquistossomose', form.ocor_esquistossomose)}
            </View>
          </View>

          <View style={{ flex: 1 }}>
            <Text style={s.sectionTitle}>Quantidades</Text>
            <View style={s.grid}>
                <View style={[s.gridItem, { width: '50%' }]}><Text style={s.label}>Imov. Residenciais</Text><Text style={s.value}>{form.qtd_imoveis_residenciais || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0 }]}><Text style={s.label}>Imov. Comerciais</Text><Text style={s.value}>{form.qtd_imoveis_comerciais || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%' }]}><Text style={s.label}>Outros Imóveis</Text><Text style={s.value}>{form.qtd_outros_imoveis || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0 }]}><Text style={s.label}>Habitantes</Text><Text style={s.value}>{form.qtd_habitantes || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%' }]}><Text style={s.label}>Quarteirões</Text><Text style={s.value}>{form.qtd_quarteiroes || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0 }]}><Text style={s.label}>P. Estratégicos</Text><Text style={s.value}>{form.qtd_pontos_estrategicos || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderBottomWidth: 0 }]}><Text style={s.label}>Armadilhas</Text><Text style={s.value}>{form.qtd_armadilhas_instaladas || '0'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0, borderBottomWidth: 0 }]}><Text style={s.label}>Terr. Baldios</Text><Text style={s.value}>{form.qtd_terrenos_baldios || '0'}</Text></View>
            </View>

            <Text style={[s.sectionTitle, { marginTop: 10 }]}>Dados Geográficos</Text>
            <View style={s.grid}>
                <View style={[s.gridItem, { width: '50%' }]}><Text style={s.label}>Longitude</Text><Text style={s.value}>{form.longitude || '-'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0 }]}><Text style={s.label}>Latitude</Text><Text style={s.value}>{form.latitude || '-'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderBottomWidth: 0 }]}><Text style={s.label}>Altitude (m)</Text><Text style={s.value}>{form.altitude_m || '-'}</Text></View>
                <View style={[s.gridItem, { width: '50%', borderRightWidth: 0, borderBottomWidth: 0 }]}><Text style={s.label}>Dist. Centro (Km)</Text><Text style={s.value}>{form.distancia_centro_km || '-'}</Text></View>
            </View>
          </View>
        </View>

        <View style={{ position: 'absolute', bottom: 45, left: 30, right: 30 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <View style={{ width: '45%' }}>
                    <View style={{ marginTop: 20, borderTopWidth: 0.5, borderTopColor: '#000', paddingTop: 2 }}>
                        <Text style={{ fontSize: 7, textAlign: 'center' }}>Data</Text>
                    </View>
                    <Text style={{ fontSize: 7, textAlign: 'center', marginTop: 2 }}>{formatDate(form.data_visto)}</Text>
                </View>
                <View style={{ width: '45%' }}>
                    <View style={{ marginTop: 20, borderTopWidth: 0.5, borderTopColor: '#000', paddingTop: 2 }}>
                        <Text style={{ fontSize: 7, textAlign: 'center' }}>Visto do Supervisor</Text>
                    </View>
                    <Text style={{ fontSize: 7, textAlign: 'center', marginTop: 2 }}>{form.visto_supervisor || ''}</Text>
                </View>
            </View>
        </View>

        <View style={s.footer}>
          <Text>Vector Tracker - Sistema de Vigilância Entomológica</Text>
          <Text>Gerado em: {new Date().toLocaleString('pt-BR')}</Text>
        </View>
      </Page>
    </Document>
  );
};

export const BotaoDownloadLocalidadePDF = ({ form }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    urlParaBase64(logoUrl).then(setLogoBase64);
  }, []);

  const handleDownload = async () => {
    if (isGenerating) return;
    setIsGenerating(true);
    try {
      const doc = <FormularioLocalidadePDFDocument form={form} logoBase64={logoBase64} />;
      const blob = await pdf(doc).toBlob();
      saveAs(blob, `Localidade_${form.nome || 'SemNome'}_RG03.pdf`);
    } catch (err) {
      console.error("Erro ao gerar PDF:", err);
      alert("Erro ao gerar o PDF.");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button 
      onClick={handleDownload} 
      disabled={isGenerating}
      className="loc-btn-save"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: 8}}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      {isGenerating ? 'Gerando...' : 'Baixar PDF'}
    </button>
  );
};
